// extracted by mini-css-extract-plugin
export var additionalText = "sectionWithIcons-module--additional-text--e8e23";
export var aligncenter = "sectionWithIcons-module--aligncenter--616c9";
export var alignright = "sectionWithIcons-module--alignright--96c19";
export var green = "sectionWithIcons-module--green--f8594";
export var iconsItem = "sectionWithIcons-module--icons-item--fecdc";
export var iconsItemIcon = "sectionWithIcons-module--icons-item-icon--bb49b";
export var iconsWrap = "sectionWithIcons-module--icons-wrap--85f83";
export var section = "sectionWithIcons-module--section--fc0cb";
export var sectionButton = "sectionWithIcons-module--section-button--299e4";
export var sectionPattern = "sectionWithIcons-module--section-pattern--1cced";
export var wpBlockJetpackGif = "sectionWithIcons-module--wp-block-jetpack-gif--6dc70";
export var wpBlockJetpackGifWrapper = "sectionWithIcons-module--wp-block-jetpack-gif-wrapper--6d3b3";